export default __webpack_public_path__ + "static/media/gmailInactive.a811ca64.svg";